"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalSection = void 0;
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../Localization");
var _components = require("../components");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const LegalSection = props => {
  const {
    config,
    registrationCustomerId
  } = props;
  const form = (0, _reactHookForm.useFormContext)();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const {
    isSubmitting
  } = form.formState;
  const values = form.watch();
  const availableApprovals = config?.approvals && Object.values(config.approvals).filter(approval => approval.isAvailable);
  const isAnyAprrovalAvailable = Boolean(availableApprovals && availableApprovals.length > 0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAnyAprrovalAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LegalDetailApprovals, {
      config: config
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
      name: "legalDetails.confirmation1.value",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        sx: {
          fontWeight: values.legalDetails?.confirmation1?.value ? 'bold' : 'normal'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.Legal_Confirmation1,
          id: _models.TranslationKey.Legal_Confirmation1
        })
      }),
      value: values.legalDetails?.confirmation1?.value,
      ...config?.confirmation1,
      isMandatory: config?.confirmation1?.validation?.isMandatory,
      customErrors: customErrors,
      isSubmitting: isSubmitting
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
      name: "legalDetails.confirmation2.value",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        sx: {
          fontWeight: values.legalDetails?.confirmation2?.value ? 'bold' : 'normal'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.Legal_Confiramtion2,
          id: _models.TranslationKey.Legal_Confiramtion2
        })
      }),
      value: values.legalDetails?.confirmation2?.value,
      ...config?.confirmation2,
      isMandatory: config?.confirmation2?.validation?.isMandatory,
      customErrors: customErrors,
      isSubmitting: isSubmitting
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TermsConditionsCheckbox, {
      config: config,
      registrationCustomerId: registrationCustomerId
    })]
  });
};
exports.LegalSection = LegalSection;
//# sourceMappingURL=LegalSection.js.map